"use client";
import "./chunk-M66XENHI.js";
import { PopupType } from "@getpara/core-sdk";
import { LocalStorage } from "./LocalStorage.js";
import { SessionStorage } from "./SessionStorage.js";
import { keygen, preKeygen, ed25519Keygen, ed25519PreKeygen, refresh } from "./wallet/keygen.js";
import { signMessage, sendTransaction, signTransaction, ed25519Sign } from "./wallet/signing.js";
import { getPrivateKey } from "./wallet/privateKey.js";
class WebUtils {
  constructor() {
    this.sdkType = "WEB";
    this.localStorage = new LocalStorage();
    this.sessionStorage = new SessionStorage();
    this.secureStorage = null;
    this.isSyncStorage = true;
    this.disableProviderModal = false;
  }
  getPrivateKey(ctx, userId, walletId, share, sessionCookie) {
    return getPrivateKey(ctx, userId, walletId, share, sessionCookie);
  }
  keygen(ctx, userId, type, secretKey, sessionCookie, emailProps = {}) {
    return keygen(ctx, userId, type, secretKey, true, sessionCookie, emailProps);
  }
  refresh(ctx, sessionCookie, userId, walletId, share, oldPartnerId, newPartnerId, keyShareProtocolId) {
    return refresh(ctx, sessionCookie, userId, walletId, share, oldPartnerId, newPartnerId, keyShareProtocolId);
  }
  preKeygen(ctx, partnerId, pregenIdentifier, pregenIdentifierType, type, secretKey, sessionCookie) {
    return preKeygen(ctx, pregenIdentifier, pregenIdentifierType, type, secretKey, false, partnerId, sessionCookie);
  }
  signMessage(ctx, userId, walletId, share, message, sessionCookie, isDKLS, cosmosSignDoc) {
    return signMessage(ctx, userId, walletId, share, message, sessionCookie, isDKLS, cosmosSignDoc);
  }
  signTransaction(ctx, userId, walletId, share, tx, chainId, sessionCookie, isDKLS) {
    return signTransaction(ctx, userId, walletId, share, tx, chainId, sessionCookie, isDKLS);
  }
  sendTransaction(ctx, userId, walletId, share, tx, chainId, sessionCookie, isDKLS) {
    return sendTransaction(ctx, userId, walletId, share, tx, chainId, sessionCookie, isDKLS);
  }
  signHash(_address, _hash) {
    throw new Error("not implemented");
  }
  ed25519Keygen(ctx, userId, sessionCookie, emailProps) {
    return ed25519Keygen(ctx, userId, sessionCookie, emailProps);
  }
  ed25519PreKeygen(ctx, pregenIdentifier, pregenIdentifierType, sessionCookie) {
    return ed25519PreKeygen(ctx, pregenIdentifier, pregenIdentifierType, sessionCookie);
  }
  ed25519Sign(ctx, userId, walletId, share, base64Bytes, sessionCookie) {
    return ed25519Sign(ctx, userId, walletId, share, base64Bytes, sessionCookie);
  }
  openPopup(popupUrl, opts) {
    if (typeof window === "undefined") {
      return;
    }
    if (opts) {
      const { type } = opts;
      const popUpWidth = 550;
      let popUpHeight;
      switch (type) {
        case PopupType.LOGIN_PASSKEY: {
          popUpHeight = 798;
          break;
        }
        case PopupType.CREATE_PASSKEY: {
          popUpHeight = 464;
          break;
        }
        case PopupType.SIGN_MESSAGE_REVIEW: {
          popUpHeight = 585;
          break;
        }
        case PopupType.SIGN_TRANSACTION_REVIEW: {
          popUpHeight = 750;
          break;
        }
        case PopupType.OAUTH:
        default: {
          popUpHeight = 768;
          break;
        }
      }
      const dualScreenLeft = window.screenLeft !== void 0 ? window.screenLeft : window.screenX;
      const dualScreenTop = window.screenTop !== void 0 ? window.screenTop : window.screenY;
      const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
      const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
      const left = (width - popUpWidth) / 2 + dualScreenLeft;
      const top = (height - popUpHeight) / 2 + dualScreenTop;
      const windowFeatures = `toolbar=no, menubar=no, width=${popUpWidth}, 
    height=${popUpHeight}, top=${top}, left=${left}`;
      let popupWindow = window.open(popupUrl, type.toString(), windowFeatures);
      if (!popupWindow) {
        setTimeout(() => {
          popupWindow = window.open(popupUrl, "_blank");
        }, 0);
      }
      return popupWindow;
    } else {
      const popupWindow = window.open(popupUrl, "popup", "popup=true,width=400,height=500");
      if (!popupWindow) {
        setTimeout(() => {
          window.open(popupUrl, "_blank");
        }, 0);
      }
      return popupWindow;
    }
  }
}
export {
  WebUtils
};
